<template>
    <div>
        <div class="bg-white shadow-sm py-3 my-2" style="border-radius: 10px">
            <div class="d-flex align-items-center px-3">
                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#00bea5">
                    <path d="M480-80q-139-35-229.5-159.5T160-516v-244l320-120 320 120v244q0 152-90.5 276.5T480-80Zm0-84q104-33 172-132t68-220v-189l-240-90-240 90v189q0 121 68 220t172 132Zm-42-176 226-226-57-57-169 169-84-84-57 57 141 141Z"/>
                </svg>
                <span class="pr-2 ml-auto text-white-in-dark-mode">مجوزات و قرارداد</span>
                <button v-if="current_tab === 'gateways'" type="button" class="btn btn-sm btn-link text-muted px-1" :disabled="loading" @click="load">
                    <i class="fa fa-sync-alt" :class="{ 'fa-spin': loading }"></i>
                </button>
            </div>
            <hr/>

            <ul class="nav nav-tabs nav-fill mx-3 mb-3 p-0">
                <li v-for="tab in tabs" :key="tab.key" class="nav-item cp_pointer">
                    <button type="button" class="nav-link btn-block" :class="{ active: current_tab === tab.key }" @click="current_tab = tab.key">
                        {{ tab.title }}
                    </button>
                </li>
            </ul>

            <div v-if="current_tab === 'marketing'" class="px-3">
                <marketing-contract></marketing-contract>
            </div>

            <div v-else class="px-3">
                <p class="text-muted small mb-3">
                    قرارداد ارائه خدمات پرداخت هر درگاه پس از امضای الکترونیکی با کد یک‌بارمصرف در این بخش نگهداری می‌شود
                    و همیشه قابل مشاهده و دریافت است.
                </p>

                <div class="d-flex flex-wrap mb-3">
                    <button v-for="filter in filters" :key="filter.key" type="button"
                            class="btn btn-sm rounded-pill px-3 ml-2 mb-2"
                            :class="current_filter === filter.key ? 'btn-success' : 'btn-light'"
                            @click="current_filter = filter.key">
                        {{ filter.title }}
                        <span class="badge badge-pill mr-1 en_num" :class="current_filter === filter.key ? 'badge-light' : 'badge-secondary'">
                            {{ counts[filter.key] }}
                        </span>
                    </button>
                </div>

                <div v-if="counts.pending > 0" class="alert alert-warning d-flex align-items-center py-2">
                    <i class="fa fa-exclamation-circle ml-2"></i>
                    <span>
                        <span class="en_num">{{ counts.pending }}</span>
                        درخواست درگاه در انتظار امضای قرارداد است و تا امضای آن برای بررسی ارسال نمی‌شود.
                    </span>
                </div>

                <div v-if="loading && !items.length" class="text-center py-5">
                    <span class="spinner-border text-success"></span>
                </div>

                <div v-else-if="error" class="alert alert-danger d-flex align-items-center justify-content-between">
                    <span>{{ error }}</span>
                    <button type="button" class="btn btn-sm btn-outline-danger rounded-pill" @click="load">تلاش مجدد</button>
                </div>

                <div v-else-if="!filtered.length" class="text-center text-muted py-5">
                    <i class="fa fa-file-contract fa-3x mb-3 d-block"></i>
                    <span v-if="current_filter === 'total'">هنوز قراردادی برای درگاه‌های شما ثبت نشده است.</span>
                    <span v-else>موردی در این دسته وجود ندارد.</span>
                </div>

                <div v-for="item in filtered" :key="item.shop.id" class="contract-card border rounded p-3 mb-3">
                    <div class="d-flex flex-wrap align-items-start mb-2">
                        <div class="ml-auto mb-2">
                            <h6 class="mb-1 text-white-in-dark-mode">{{ item.shop.farsi_name }}</h6>
                            <small class="text-muted en_num" dir="ltr">{{ item.shop.website }}</small>
                        </div>
                        <span class="badge badge-pill p-2" :class="item.signed ? 'badge-success' : 'badge-warning'">
                            {{ item.signed ? 'امضا شده' : 'در انتظار امضا' }}
                        </span>
                    </div>

                    <div class="row small">
                        <div class="col-6 col-md-3 mb-2">
                            <div class="text-muted">شماره قرارداد</div>
                            <div class="en_num text-white-in-dark-mode" dir="ltr">{{ item.contract ? item.contract.contract_number : '—' }}</div>
                        </div>
                        <div class="col-6 col-md-3 mb-2">
                            <div class="text-muted">{{ item.signed ? 'تاریخ امضا' : 'تاریخ صدور' }}</div>
                            <div class="en_num text-white-in-dark-mode">{{ dateOf(item) }}</div>
                        </div>
                        <div class="col-6 col-md-3 mb-2">
                            <div class="text-muted">کد رهگیری</div>
                            <div class="en_num text-white-in-dark-mode" dir="ltr">{{ item.contract && item.contract.tracking_code || '—' }}</div>
                        </div>
                        <div class="col-6 col-md-3 mb-2">
                            <div class="text-muted">نسخه</div>
                            <div class="en_num text-white-in-dark-mode">{{ item.contract ? item.contract.version : '—' }}</div>
                        </div>
                    </div>

                    <div class="d-flex flex-wrap justify-content-end mt-1">
                        <button v-if="item.contract" type="button" class="btn btn-sm btn-light rounded-pill px-3 mr-2 mb-1"
                                @click="showDetails(item)">
                            <i class="fa fa-info-circle ml-1"></i>جزئیات
                        </button>
                        <button v-if="item.contract" type="button" class="btn btn-sm btn-light rounded-pill px-3 mr-2 mb-1"
                                :disabled="busy_id === item.contract.id" @click="viewPdf(item.contract)">
                            <i class="fa fa-eye ml-1"></i>مشاهده
                        </button>
                        <button v-if="item.signed" type="button" class="btn btn-sm btn-outline-success rounded-pill px-3 mr-2 mb-1"
                                :disabled="busy_id === item.contract.id" @click="download(item.contract)">
                            <i class="fa fa-download ml-1"></i>دانلود
                        </button>
                        <button v-else type="button" class="btn btn-sm btn-success rounded-pill px-3 mr-2 mb-1"
                                @click="sign(item.shop.id)">
                            <i class="fa fa-signature ml-1"></i>مطالعه و امضای قرارداد
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Details -->
        <div class="modal fade" id="gateway_contract_details_modal" tabindex="-1" role="dialog">
            <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            جزئیات قرارداد
                            <small v-if="details" class="text-muted mr-2 en_num" dir="ltr">({{ details.contract_number }})</small>
                        </h5>
                        <button type="button" class="close mr-auto ml-0" data-dismiss="modal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div v-if="details_loading" class="text-center py-5">
                            <span class="spinner-border text-success"></span>
                        </div>
                        <div v-else-if="details_error" class="alert alert-danger mb-0">{{ details_error }}</div>

                        <template v-else-if="details">
                            <div v-if="details.status !== 'signed'" class="alert alert-info small">
                                این نسخه هنوز امضا نشده است. اگر اطلاعات حساب یا درگاه شما تغییر کرده باشد،
                                هنگام امضا نسخه جدید و به‌روز قرارداد صادر می‌شود.
                            </div>

                            <h6 class="section-title">مشخصات قرارداد</h6>
                            <div class="row small">
                                <div v-for="row in contractRows" :key="row.label" class="col-12 col-md-6 mb-2 d-flex">
                                    <span class="text-muted ml-2">{{ row.label }}:</span>
                                    <span class="text-white-in-dark-mode en_num" :dir="row.ltr ? 'ltr' : null">{{ row.value || '—' }}</span>
                                </div>
                            </div>

                            <h6 class="section-title">{{ isLegal ? 'پذیرنده (شخص حقوقی)' : 'پذیرنده (شخص حقیقی)' }}</h6>
                            <div class="row small">
                                <div v-for="row in applicantRows" :key="row.label" class="col-12 col-md-6 mb-2 d-flex">
                                    <span class="text-muted ml-2 text-nowrap">{{ row.label }}:</span>
                                    <span class="text-white-in-dark-mode en_num" :dir="row.ltr ? 'ltr' : null">{{ row.value || '—' }}</span>
                                </div>
                            </div>

                            <h6 class="section-title">مشخصات کسب‌وکار</h6>
                            <div class="row small">
                                <div v-for="row in businessRows" :key="row.label" class="col-12 col-md-6 mb-2 d-flex">
                                    <span class="text-muted ml-2 text-nowrap">{{ row.label }}:</span>
                                    <span class="text-white-in-dark-mode en_num" :dir="row.ltr ? 'ltr' : null">{{ row.value || '—' }}</span>
                                </div>
                            </div>

                            <div class="small mb-2">
                                <div class="text-muted mb-1">شماره‌های شبای تسویه:</div>
                                <div v-for="(iban, index) in business.ibans || []" :key="iban.number" class="d-flex align-items-center mb-1">
                                    <span class="en_num text-white-in-dark-mode" dir="ltr">{{ iban.number }}</span>
                                    <span class="text-muted mr-2">{{ iban.bank_name }}</span>
                                    <span v-if="index === 0" class="badge badge-light mr-2">پیش‌فرض</span>
                                </div>
                            </div>
                            <div class="small mb-2">
                                <span class="text-muted ml-2">IP سرور:</span>
                                <span v-for="ip in business.ips || []" :key="ip" class="badge badge-light en_num ml-1" dir="ltr">{{ ip }}</span>
                            </div>

                            <template v-if="partners.length">
                                <h6 class="section-title">شرکای تجاری</h6>
                                <div v-for="(partner, index) in partners" :key="index" class="small mb-1">
                                    <span class="text-white-in-dark-mode">{{ partner.name }}</span>
                                    <span class="text-muted mr-2">{{ partner.id_label }}:</span>
                                    <span class="en_num text-white-in-dark-mode">{{ partner.id }}</span>
                                </div>
                            </template>

                            <h6 class="section-title">تاریخچه قرارداد</h6>
                            <ul class="timeline list-unstyled mb-0">
                                <li v-for="(event, index) in details.events" :key="index" class="small pb-2"
                                    :class="{ 'is-signed': event.event === 'signed' }">
                                    <span class="text-white-in-dark-mode">{{ event.title }}</span>
                                    <div class="text-muted">
                                        <span class="en_num">{{ event.at_fa }}</span>
                                        <span v-if="event.ip" class="en_num mr-2" dir="ltr">IP: {{ event.ip }}</span>
                                    </div>
                                </li>
                            </ul>
                        </template>
                    </div>

                    <div v-if="details" class="modal-footer">
                        <button type="button" class="btn btn-light rounded-pill px-4" :disabled="busy_id === details.id" @click="viewPdf(details)">
                            مشاهده فایل
                        </button>
                        <button v-if="details.status === 'signed'" type="button" class="btn btn-success rounded-pill px-4"
                                :disabled="busy_id === details.id" @click="download(details)">
                            دانلود قرارداد امضاشده
                        </button>
                        <button v-else type="button" class="btn btn-success rounded-pill px-4" @click="signFromDetails">
                            مطالعه و امضای قرارداد
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <contract-modal ref="contract_modal" @signed="onSigned" @enamad-error="onEnamadError"></contract-modal>
    </div>
</template>

<script>
import $ from 'jquery'
import { gatewayService } from '@/common/api.service'
import ContractModal from '@/pages/gateways/components/contract-modal'
import MarketingContract from '@/pages/setting/marketing-contract.vue'

export default {
    name: 'GatewayContracts',
    components: { ContractModal, MarketingContract },
    data() {
        return {
            current_tab: 'gateways',
            tabs: [
                { key: 'gateways', title: 'درگاه‌ها' },
                { key: 'marketing', title: 'همکاری فروش' },
            ],
            loading: false,
            error: '',
            items: [],
            counts: { total: 0, signed: 0, pending: 0 },
            current_filter: 'total',
            filters: [
                { key: 'total', title: 'همه' },
                { key: 'signed', title: 'امضا شده' },
                { key: 'pending', title: 'در انتظار امضا' },
            ],
            busy_id: null,
            details: null,
            details_loading: false,
            details_error: '',
        }
    },
    computed: {
        filtered() {
            if (this.current_filter === 'signed') return this.items.filter(item => item.signed)
            if (this.current_filter === 'pending') return this.items.filter(item => !item.signed)
            return this.items
        },
        snapshot() {
            return (this.details && this.details.data) || {}
        },
        isLegal() {
            return this.snapshot.applicant_type === 'legal'
        },
        business() {
            return this.snapshot.business || {}
        },
        partners() {
            return this.snapshot.partners || []
        },
        contractRows() {
            const d = this.details
            return [
                { label: 'وضعیت', value: d.status === 'signed' ? 'امضا شده' : 'در انتظار امضا' },
                { label: 'شماره قرارداد', value: d.contract_number, ltr: true },
                { label: 'تاریخ صدور', value: d.finalized_at_fa },
                { label: 'تاریخ امضا', value: d.signed_at_fa },
                { label: 'کد رهگیری امضا', value: d.tracking_code, ltr: true },
                { label: 'شماره همراه امضاکننده', value: d.signer_mobile, ltr: true },
                { label: 'نسخه قرارداد / قالب', value: `${d.version} / ${d.template_version}` },
                { label: 'شناسه سند (SHA-256)', value: d.sha256 && d.sha256.substring(0, 16), ltr: true },
            ]
        },
        applicantRows() {
            const a = this.snapshot.applicant || {}
            const r = this.snapshot.representative || {}
            const rows = this.isLegal
                ? [
                    { label: 'نام شرکت', value: a.company_name },
                    { label: 'شناسه ملی', value: a.national_legal_code },
                    { label: 'شماره ثبت', value: a.register_number },
                    { label: 'نماینده مجاز', value: r.full_name },
                    { label: 'کد ملی نماینده', value: r.national_code },
                ]
                : [
                    { label: 'نام و نام خانوادگی', value: a.full_name },
                    { label: 'کد ملی', value: a.national_code },
                ]
            return rows.concat([
                { label: 'شماره همراه', value: a.mobile, ltr: true },
                { label: 'تلفن ثابت', value: a.telephone, ltr: true },
                { label: 'ایمیل', value: a.email, ltr: true },
                { label: 'کد پستی', value: a.postal_code },
                { label: 'نشانی', value: a.address },
            ])
        },
        businessRows() {
            const b = this.business
            return [
                { label: 'نام کسب‌وکار', value: b.farsi_name },
                { label: 'نام انگلیسی', value: b.english_name, ltr: true },
                { label: 'آدرس سایت', value: b.website, ltr: true },
                { label: 'نوع درگاه', value: b.type },
                { label: 'موضوع فعالیت', value: b.activity },
                { label: 'نحوه تسویه', value: b.settlement_type },
            ]
        },
    },
    mounted() {
        this.load()
    },
    beforeDestroy() {
        $('#gateway_contract_details_modal').modal('hide')
    },
    methods: {
        load() {
            this.loading = true
            this.error = ''
            gatewayService.listContracts()
                .then(({ data }) => {
                    this.items = data.data.items
                    this.counts = data.data.counts
                })
                .catch(({ response }) => {
                    this.error = (response && response.data && response.data.message) || 'دریافت فهرست قراردادها ممکن نشد.'
                })
                .finally(() => { this.loading = false })
        },
        dateOf(item) {
            if (!item.contract) return '—'
            return (item.signed ? item.contract.signed_at_fa : item.contract.finalized_at_fa) || '—'
        },
        showDetails(item) {
            this.details = null
            this.details_error = ''
            this.details_loading = true
            $('#gateway_contract_details_modal').modal('show')
            gatewayService.contractDetails(item.contract.id)
                .then(({ data }) => { this.details = data.data })
                .catch(({ response }) => {
                    this.details_error = (response && response.data && response.data.message) || 'دریافت جزئیات قرارداد ممکن نشد.'
                })
                .finally(() => { this.details_loading = false })
        },
        viewPdf(contract) {
            // Open the tab synchronously so popup blockers allow it, then point it at the blob.
            const tab = window.open('', '_blank')
            this.fetchPdf(contract, false, url => {
                if (tab) {
                    tab.location.href = url
                } else {
                    window.location.href = url
                }
            }, () => tab && tab.close())
        },
        download(contract) {
            this.fetchPdf(contract, true, url => {
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', `paystar-contract-${contract.contract_number}.pdf`)
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            })
        },
        fetchPdf(contract, download, done, failed = () => {}) {
            this.busy_id = contract.id
            gatewayService.contractPdf(contract.id, download)
                .then(({ data }) => {
                    const url = window.URL.createObjectURL(new Blob([data], { type: 'application/pdf' }))
                    done(url)
                    setTimeout(() => window.URL.revokeObjectURL(url), 60000)
                })
                .catch(() => {
                    failed()
                    this.toastr.error('دریافت فایل قرارداد ممکن نشد. لطفاً دوباره تلاش کنید.')
                })
                .finally(() => { this.busy_id = null })
        },
        sign(shop_id) {
            this.$refs.contract_modal.open(shop_id)
        },
        signFromDetails() {
            const shop_id = this.details.shop.id
            // Wait for the details modal to close, otherwise the two bootstrap backdrops clash.
            $('#gateway_contract_details_modal')
                .one('hidden.bs.modal', () => this.sign(shop_id))
                .modal('hide')
        },
        onSigned() {
            this.load()
            this.$store.dispatch('user/countData')
        },
        onEnamadError(body) {
            this.$router.push(`/gateways/update/${body.data.shop_id}/register-enamad`)
        },
    },
}
</script>

<style scoped>
.contract-card {
    transition: box-shadow .15s;
}

.contract-card:hover {
    box-shadow: 0 2px 10px rgba(0, 0, 0, .06);
}

.section-title {
    color: #00bea5;
    font-size: .95rem;
    margin: 1.25rem 0 .75rem;
    padding-bottom: .4rem;
    border-bottom: 1px solid rgba(0, 0, 0, .08);
}

.timeline li {
    position: relative;
    padding-right: 1.25rem;
    border-right: 2px solid #e3e6ea;
}

.timeline li:last-child {
    border-right-color: transparent;
}

.timeline li::before {
    content: '';
    position: absolute;
    right: -6px;
    top: 4px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #a0a0a1;
}

.timeline li.is-signed::before {
    background: #00bea5;
}
</style>
